/**
 * Created by huangzhangshu on 2018/8/3
 */
export const wrapImage = (url = '') => {
  if (!url) return '';
  let wrapUrl = url;
  if (wrapUrl[0] !== '/') wrapUrl = wrapUrl.concat('/');
  const servletRoot = localStorage.getItem('static_path') || '';
  return servletRoot.concat(wrapUrl);
}
export const   passwordCheck = (formData,value)=>{
  let msg='';
  for(const result of formData){
    if (result.passwordStrongFlag=='是') {
      if (result.passwordMetacharacters !='') {
        let reg = '[^0-9a-zA-Z';
        let metacharacters =  result.passwordMetacharacters.split('');
        metacharacters.map((item)=>{
          reg +=item
        })
        reg +=']';
        let newReg= new RegExp(reg)
        if (newReg.test(value)) {
          msg += '特殊字符仅支持'+result.passwordMetacharacters+'  ';
        }
      }
      const reg1 = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/g;
      const reg2 = /(?=.*[a-zA-Z])(?=.*[0-9])/g;
      if (result.passwordCaseFlag =='是'  && (!reg1.test(value))) {
        msg += '新密码必须包含大小写字母和数字  ';
      } else if (result.passwordCaseFlag =='否'  && (!reg2.test(value))) {
        msg += '新密码必须包含字母和数字  ';
      }
      if (value.length<result.passwordLength) {
        msg += '密码长度不低于'+result.passwordLength+'位 ';
      }
    }
  }
  return msg;
}



// WEBPACK FOOTER //
// ./src/utils/index.js